export default __webpack_public_path__ + "static/media/folder.9dec2406.svg";